import useAuthStore from 'store/authStore';

export enum AccessLevel {
  NONE = '',
  VIEW = 'view',
  EDIT = 'edit',
}
export enum PAGES_ENUM {
  actionList = 'actionList',
  billingDetails = 'billingDetails',
  contractIssuerLists = 'contractIssuerLists',
  exceptionLists = 'exceptionLists',
  passageReports = 'passageReports',
  paymentClaims = 'paymentClaims',
  receipt = 'receipt',
  transaction = 'transaction',
  iTicket = 'iTicket',
  auditLog = 'auditLog',

  tollServiceProvider = 'tollServiceProvider',
  oresundsbronData = 'tollCharger',
  efcContextDataInbound = 'inboundEfcContextData',
  efcContextDataOutbound = 'outboundEfcContextData',
  localAgreements = 'localAgreements',
}

export enum ACCESS_GROUPS_ENUM {
  kcGroup = 'Customer Support',
  tollAdminGroup = 'Toll Admin',
  userAdminGroup = 'User Admin',
}
export const ACCESS_GROUPS = Object.keys(ACCESS_GROUPS_ENUM);
export const ACCESS_GROUP_NAMES: Record<string, string> = {
  kcGroup: ACCESS_GROUPS_ENUM.kcGroup.toString(),
  tollAdminGroup: ACCESS_GROUPS_ENUM.tollAdminGroup.toString(),
  userAdminGroup: ACCESS_GROUPS_ENUM.userAdminGroup.toString(),
};
export const ACCESS_GROUPS_AD_NAMES: Record<string, string> = {
  kcGroup: import.meta.env.VITE_ENTRA_GROUP_KC,
  tollAdminGroup: import.meta.env.VITE_ENTRA_GROUP_TOLL_ADMIN,
  userAdminGroup: import.meta.env.VITE_ENTRA_GROUP_USER_ADMIN,
};

export enum USER_ROLES_ENUM {
  kcGroup = 'Task.Support',
  tollAdminGroup = 'Task.TollAdmin',
  userAdminGroup = 'Task.UserAdmin',
}
export const USER_ROLES: Record<string, string> = {
  kcGroup: USER_ROLES_ENUM.kcGroup.toString(),
  tollAdminGroup: USER_ROLES_ENUM.tollAdminGroup.toString(),
  userAdminGroup: USER_ROLES_ENUM.userAdminGroup.toString(),
};

export const PAGES = Object.keys(PAGES_ENUM);

const accessLevels = {
  [AccessLevel.NONE]: 0,
  [AccessLevel.VIEW]: 10,
  [AccessLevel.EDIT]: 20,
};

export const haveAccess = (page: PAGES_ENUM, requiredAccess: AccessLevel): boolean => {
  // console.log('Does user have "%s" access to page "%s"? %s', requiredAccess, page, false);
  const authState = useAuthStore.getState();
  const pageAuthAccessRoles = authState.tollingAdminAccessObject?.pages.find(
    (p) => p.id === page
  )?.access;
  // spara ner högsta accessen för rollerna personen har
  let highestAccessLevel = accessLevels[AccessLevel.NONE];
  authState.tokenAccessRoles.forEach((a) => {
    if (pageAuthAccessRoles) {
      highestAccessLevel = Math.max(highestAccessLevel, accessLevels[pageAuthAccessRoles[a]]);
    }
  });
  // testa mot högsta accessen
  return highestAccessLevel >= accessLevels[requiredAccess];
};

export const haveRole = (requiredRole: USER_ROLES_ENUM): boolean => {
  const authState = useAuthStore.getState();
  const role = authState.tokenAccessRoles.find((r) => r === requiredRole);
  return !!role;
};
